import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import KeyboardCommandKeyIcon from '@mui/icons-material/KeyboardCommandKey';
import LinkIcon from '@mui/icons-material/Link';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import React, { useState } from 'react';

import { ReactComponent as GitHubLogo } from '../../public/assets/github-logo.svg';

const ProjectSections = ({ project }: { project: Project }) => {
  const [expanded, setExpanded] = useState([0]);

  const handleChange = (index: number) => {
    if (expanded.includes(index)) {
      const filtered = expanded.filter((section) => section !== index);
      setExpanded(filtered);
    } else {
      setExpanded([...expanded, index]);
    }
  };

  const linksSection = (index: number) => {
    return (
      <div className="project-links-section">
        <div className="project-links-details">
          <span>{project.linksDetails}</span>
        </div>
        <Accordion
          expanded={expanded.includes(index)}
          onChange={() => handleChange(index)}
          classes={{
            root: 'project-links-accordion',
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1d-content"
            id="panel1d-header"
            classes={{ content: 'project-links-header' }}
          >
            <LinkIcon className="project-links-icon" /> <span>Links</span>
          </AccordionSummary>
          {project.links.map((link) => (
            <AccordionDetails
              classes={{ root: 'project-links-content' }}
              key={link.name}
            >
              {link.image ? (
                <img src={link.image} alt={link.name} />
              ) : (
                <Typography>{link.name}</Typography>
              )}
              <Typography classes={{ root: 'project-links-description' }}>
                {link.description}
              </Typography>
              <Typography classes={{ root: 'project-links-urls' }}>
                {link.urls.map((url) => (
                  <div key={url}>
                    <a href={url} target="_blank" rel="noopener noreferrer">
                      {url}
                    </a>
                  </div>
                ))}
              </Typography>
            </AccordionDetails>
          ))}
        </Accordion>
      </div>
    );
  };

  const diagramsSection = (index: number) => {
    return (
      <div className="project-diagrams-section">
        {project.diagramsDetails && (
          <div className="project-diagrams-details">
            <span>{project.diagramsDetails}</span>
          </div>
        )}
        <Accordion
          expanded={expanded.includes(index)}
          onChange={() => handleChange(index)}
          classes={{
            root: 'project-diagrams-accordion',
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1d-content"
            id="panel1d-header"
            classes={{ content: 'project-diagrams-header' }}
          >
            <KeyboardCommandKeyIcon className="project-diagrams-icon" />{' '}
            <span>Diagram</span>
          </AccordionSummary>
          {project.diagrams.map((diagram) => (
            <AccordionDetails
              classes={{ root: 'project-diagrams-content' }}
              key={diagram.image}
            >
              <a href={diagram.image} target="_blank" rel="noopener noreferrer">
                <img src={diagram.image} alt="Diagram" />
              </a>
              <Typography classes={{ root: 'project-diagrams-description' }}>
                Read more on
                <GitHubLogo
                  className="project-diagrams-description-image"
                  alt="GitHub Logo"
                />
              </Typography>
              <Typography classes={{ root: 'project-diagrams-urls' }}>
                <a href={diagram.url} target="_blank" rel="noopener noreferrer">
                  {diagram.url}
                </a>
              </Typography>
            </AccordionDetails>
          ))}
        </Accordion>
      </div>
    );
  };

  const allSections = [linksSection];
  if (
    project.diagrams &&
    project.diagrams.length > 0 &&
    project.diagrams?.every((diagram) => diagram.image)
  ) {
    allSections.push(diagramsSection);
  }

  return (
    <div className="project-sections">
      {allSections.map((section, index) => (
        <div key={index}>{section(index)}</div>
      ))}
    </div>
  );
};

export default ProjectSections;
